
import { Discipline } from './types';

export const history: Discipline = {
  id: 'history',
  name: 'History',
  courses: [
    {
      id: 'hist101',
      title: 'Introduction to Ancient Greek History',
      instructor: 'Donald Kagan',
      link: 'https://www.youtube.com/playlist?list=PL023BCE5134243987',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=9FrHGAd_yto&list=PL023BCE5134243987',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/classics/clcv-205'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/ancient-greek-history-audio/id341651987'
        }
      ]
    },
    {
      id: 'hist102',
      title: 'The Early Middle Ages, 284-1000',
      instructor: 'Paul Freedman',
      link: 'https://www.youtube.com/playlist?list=PL77A337915A76F660',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=ZC8JcWVRFp8&list=PL77A337915A76F660',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/history/hist-210'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/early-middle-ages/id515946405'
        }
      ]
    },
    {
      id: 'hist103',
      title: 'Early Modern England',
      instructor: 'Keith Wrightson',
      link: 'https://www.youtube.com/playlist?list=PL18B9F132DFD967A3',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=e3uBi2TZdUY&list=PL18B9F132DFD967A3',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/history/hist-251'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/early-modern-england-politics-religion-and-society/id429491092'
        }
      ]
    },
    {
      id: 'hist104',
      title: 'Epidemics in Western Society Since 1600',
      instructor: 'Frank Snowden',
      link: 'https://www.youtube.com/playlist?list=PL3AE7B3B6917DE8E6',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=UoWxdlGBVTI&list=PL3AE7B3B6917DE8E6',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/history/hist-234'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/epidemics-in-western-society-since-1600-audio/id429468934'
        }
      ]
    },
    {
      id: 'hist105',
      title: 'European Civilization, 1648-1945',
      instructor: 'John Merriman',
      link: 'https://www.youtube.com/playlist?list=PL3A8E6CE294860A24',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=_IgKHHAjV8Y&list=PL3A8E6CE294860A24',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/history/hist-202'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/european-civilization-1648-1945-audio/id341651047'
        }
      ]
    },
    {
      id: 'hist106',
      title: 'The American Revolution',
      instructor: 'Joanne Freeman',
      link: 'https://www.youtube.com/playlist?list=PLDA2BC5E785D495AB',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=shTBSGoYtK0&list=PLDA2BC5E785D495AB',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/history/hist-116'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/the-american-revolution-audio/id429260982'
        }
      ]
    },
    {
      id: 'hist107',
      title: 'The Civil War and Reconstruction',
      instructor: 'David Blight',
      link: 'https://www.youtube.com/playlist?list=PL5DD220D6A1282057',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=QXXp1bHd6gI&list=PL5DD220D6A1282057',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/history/hist-119'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/the-civil-war-and-reconstruction-era-1845-1877-audio/id341650730'
        }
      ]
    },
    {
      id: 'black101',
      title: 'African American History: From Emancipation to the Present Day',
      instructor: 'Jonathan Holloway',
      link: 'https://www.youtube.com/playlist?list=PLh9mgdi4rNeyqnC6Gj5VCZERhhy9CC1S6',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=Fp6mjKumW2g&list=PLh9mgdi4rNeyqnC6Gj5VCZERhhy9CC1S6',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/african-american-studies/afam-162'
        }
      ]
    },
    {
      id: 'hist108',
      title: 'France Since 1871',
      instructor: 'John Merriman',
      link: 'https://www.youtube.com/playlist?list=PLE653BF062C136B62',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=4vK73R51rwU&list=PLE653BF062C136B62',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://oyc.yale.edu/history/hist-276'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/france-since-1871-audio/id341651330'
        }
      ]
    },
    {
      id: 'hist109',
      title: 'The History of MIT',
      instructor: 'David Mindell and Merritt Roe Smith',
      link: 'https://www.youtube.com/playlist?list=PL7590BF3B139A354D',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=YfmVSPS7EFI&list=PL7590BF3B139A354D',
      alternateLinks: [
        {
          platform: 'MIT',
          url: 'https://ocw.mit.edu/courses/sts-050-the-history-of-mit-spring-2011/'
        }
      ]
    },
    {
      id: 'hist110',
      title: 'The Making of Modern Ukraine',
      instructor: 'Timothy Snyder',
      link: 'https://www.youtube.com/playlist?list=PLh9mgdi4rNewfxO7LhBoz_1Mx1MaO6sw_',
      platform: 'youtube',
      thumbnailVideoUrl: 'https://www.youtube.com/watch?v=bJczLlwp-d8&list=PLh9mgdi4rNewfxO7LhBoz_1Mx1MaO6sw_',
      alternateLinks: [
        {
          platform: 'Yale',
          url: 'https://online.yale.edu/courses/making-modern-ukraine'
        },
        {
          platform: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/us/podcast/the-making-of-modern-ukraine/id1653131950'
        }
      ]
    }
  ]
};
